import { track } from "./mixpanel"
import { getPageInfo } from "./utils/page-name"

// One "Page edited" event for every change a user saves: notes, actions,
// links, archived alerts, customer details, users, settings. A single event
// name, like "Page viewed", lets the report count edits per page and per user
// as one series, with `action` and `record_type` saying what changed.
//
// action: "created" | "updated" | "deleted" | "archived"
// Call it only after the save has succeeded.
export const trackPageEdit = (action, recordType, data = {}) => {
  const { page, route } = getPageInfo(window.location.pathname)

  track("Page edited", {
    action,
    record_type: recordType,
    page,
    route,
    ...data,
  })
}
